const portfolioData = {
  personal: {
    name: "Rohit Shrivastava",
    title: "Senior Software Engineer II",
    headline: "Building scalable solutions that matter.",
    headlineHighlight: "scalable solutions",
    subtitle:
      "I architect and build data-driven applications with 7+ years of experience across the full stack.",
    resumeUrl:
      "https://nextcloud.rohitxsh.com/s/resume",
    email: "rohitxsh@gmail.com",
    location: "Bengaluru, India",
    github: "https://github.com/rohitxsh",
    linkedin: "https://www.linkedin.com/in/rohitxsh",
  },

  about: {
    highlights: [
      { icon: "MapPin", label: "Bengaluru, India" },
      { icon: "Briefcase", label: "7+ Years Experience" },
      { icon: "GraduationCap", label: "B.Tech in CS" },
    ],
    paragraphs: [
      "I'm a Senior Software Engineer II at PowerSchool, where I lead the architecture and design of scalable features for a data-driven K-12 intervention management platform used across the US education space.",
      "Before that, I worked as a full-stack developer at Thoughtworks, delivering B2B SaaS applications and next-generation internet banking platforms for global banks. I've also contributed to IoT R&D at Ericsson and was a Google Summer of Code contributor working on genomic data infrastructure.",
      "I'm passionate about clean architecture, developer experience, and building products that create real impact. Outside of work, I enjoy mentoring junior engineers and contributing to the open-source community.",
    ],
  },

  techStack: [
    {
      title: "Languages",
      items: ["JavaScript", "TypeScript", "Python", "Java"],
    },
    {
      title: "Frameworks & Libraries",
      items: ["React", "Angular", "FastAPI", "Spring"],
    },
    {
      title: "Tools & Platforms",
      items: ["Git", "Docker", "AWS"],
    },
    {
      title: "Databases",
      items: ["PostgreSQL", "MongoDB", "Redis", "SQL Server"],
    },
  ],

  experiences: [
    {
      company: "PowerSchool",
      role: "Senior Software Engineer II",
      period: "Aug 2023 - Present",
      location: "Bengaluru, India",
      description:
        "Architecting scalable backend features for a data-driven K-12 intervention management platform. Integrated AI features directly into the core application to expand product capabilities, leveraged AI tools to accelerate coding, and led optimization initiatives improving API performance in critical user flows by 50% to 75%.",
      tech: ["Java", "Angular", "SQL Server"],
    },
    {
      company: "Thoughtworks",
      role: "Application Developer",
      period: "Oct 2021 - Aug 2023",
      location: "Hyderabad, India",
      description:
        "Delivered a B2B SaaS web application and built a next-generation internet banking application for a global bank. Optimized CI/CD pipelines and deployment workflows, reducing build times by 50% and improving deployment frequency.",
      tech: ["React", "Next.js", "TypeScript", "Tailwind CSS", "GraphQL", "AWS"],
    },
    {
      company: "Ericsson",
      role: "Software Developer (IoT R&D)",
      period: "Aug 2019 - Oct 2021",
      location: "Bengaluru, India",
      description:
        "Contributed to three IoT microservices and built a tailor-made IoT web portal from scratch. Also automated technical KPI reports for Airtel using Python and pandas.",
      tech: ["Java", "Angular", "Python", "Kafka", "MongoDB", "PostgreSQL", "OpenShift"],
    },
  ],

  projects: [
    {
      title: "Google Summer of Code | Ensembl Data Lakehouse",
      description:
        "Built a complete data lakehouse system for genomic data. Migrated data from MySQL to AWS S3 parquet files, built a FastAPI backend to query AWS Athena, and developed a React/TypeScript frontend.",
      tech: ["Python", "FastAPI", "React", "TypeScript", "AWS", "Docker"],
      github: "https://github.com/rohitxsh/ensembl_lakehouse_ui/blob/main/README.md",
      live: "https://summerofcode.withgoogle.com/archive/2022/projects/Uuk8xmzG",
    },
    {
      title: "Self-Hosted Home Lab Infrastructure",
      description:
        "Architected a self-hosted home lab on a Raspberry Pi 5. Orchestrated 35+ Docker containers using Portainer, secured remote access via Tailscale and Cloudflare Tunnels, and deployed monitoring pipelines with Grafana and Uptime Kuma.",
      tech: ["Docker", "Raspberry Pi", "Tailscale", "Cloudflare", "Grafana", "Linux"],
    },
    {
      title: "IoT-based Smart Health Monitoring System",
      description:
        "Created a NodeMCU sensor system with real-time ThingSpeak cloud syncing and AJAX dashboards.",
      tech: ["NodeMCU", "IoT", "AJAX", "ThingSpeak"],
      live: "https://instructables.com/IOT-Based-Health-Monitoring-System",
    },
    {
      title: "CoWIN Vaccine Notifier",
      description:
        "A hybrid mobile app to get vaccination slot alerts from India's CoWIN portal, with all processing done locally for privacy.",
      tech: ["Angular", "Ionic", "TypeScript"],
      github: "https://github.com/rohitxsh/CoWIN-Appointment-Availability-Notifier",
    },
    {
      title: "Rt-INDIA",
      description:
        "Dashboard calculating the R-nought (reproduction number) of Covid-19 for India and its states using epidemiological data.",
      tech: ["Python", "Dash", "Plotly"],
    },
  ],

  contact: {
    heading: "Get In Touch",
    description:
      "I'm always open to discussing new opportunities, interesting projects, or just having a chat about technology. Feel free to reach out!",
  },
};

export default portfolioData;
